<template lang="html">
  <div class="">
    <br>
    <br>
    <div style="margin: 30px auto 50px; font-size: 120%; max-width: 1000px; text-align: center">
      <h1>Apertura anno {{ year }}</h1>
      <br>
      <p class="text-error">
        La riapertura dell'anno contabile genera i movimenti contabili
        necessari.
        <br>I movimenti di apertura verranno inseriti in data 1 Gennaio del nuovo anno.
        <br>
        Qualora si apportassero <b><u>modifiche alla prima nota</u></b> o alle fatture dell'<b><u>anno chiuso</u></b>,
        <br>
        <b>sarà necessario <u>effettuare nuovamente</u> questa operazione</b>.
      </p>

      <br>
      Per fare l'apertura del nuovo anno, <b>controllare e inserire</b> di seguito i valori dei conti,
      <br>che sono già popolati con i valori di bilancio dell'anno precedente ({{ year-1 }}).
      <br>
      Successivamente, <b>premere il tasto "Continua"</b> situato in fondo alla pagina.
      <br>
      <b class="text-error">Non cambiare pagina mentre fai questa operazione!</b>
      <br>

      <br>
      <Button v-if="!$store.__.ho_letto" @click="$set($store.__, 'ho_letto', true)">Ho letto</Button>
    </div>
    <br>

    <div v-if="$store.__.ho_letto">
      <div class="blocco">
        <br>
        <div :gutter="16">
          <div v-for="type in types" :key="type.label" :md="type.span" style="margin: 40px; padding: 20px; background: #fafafc; border: 1px solid #ccc;">
            <b style="font-size: 150%; color: #000;">{{ type.label }}:</b>
            <br>
            <div v-if="ledgers.filter(type.filter).map(l => l.category).unique().length == 0">
              <i>Caricamento...</i>
            </div>
            <div class="ivu-table spaced" style="margin: 1em 0">
              <template v-for="cat in ledgers.filter(type.filter).map(l => l.category).unique()">
                <br>
                <br>
                <b style="font-size: 120%">{{ cat }}:</b>
                <table>
                  <thead>
                    <tr  style="border-bottom: 1px solid #ddd">
                      <th style="width: 70px">Codice</th>
                      <th style="width: 230px">Nome</th>
                      <th>Descrizione</th>
                      <th style="width: 150px; text-align: right">Saldo Iniziale</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!ledgers.filter(type.filter).filter(l => l.category == cat).length">
                      <td colspan=3>
                        Nessun mastro presente
                      </td>
                    </tr>
                    <tr v-for="l in ledgers.filter(type.filter).filter(l => l.category == cat)" :key="l.id">
                      <td>{{ l.code }}</td>
                      <td><b>{{ l.name }}</b></td>
                      <td><i>{{ l.description }}</i></td>
                      <td class="text-right text-info" style="width: 150px">
                        <NumInput v-model="l.stats.saldo" :class="{
                            verde: l.stats.saldo > 0,
                            rosso: l.stats.saldo < 0,
                            grigio: l.stats.saldo == 0,
                        }"/>
                        <div v-if="[145, 225].includes(1*l.code)">
                          Cespiti immateriali al<br>31/12/{{ year-1 }}: <br>
                          <a @click="l.stats.saldo = inventory_stats.immat*1">{{ $n(inventory_stats.immat, 'currency') }}</a>
                        </div>
                        <div v-if="[150, 230].includes(1*l.code)">
                          Cespiti materiali al<br>31/12/{{ year-1 }}: <br>
                          <a @click="l.stats.saldo = inventory_stats.mat*1">{{ $n(inventory_stats.mat, 'currency') }}</a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="border-top: 1px solid #ddd">
                      <th></th>
                      <th></th>
                      <th class="text-right"><b>Saldo {{ cat }}:</b></th>
                      <th class="text-right text-info" style="width: 150px">
                        {{ $n(ledgers.filter(type.filter).filter(l => l.category == cat).map(l => l.stats.saldo).reduce((a, b) => (a || 0) + (b || 0), 0), 'currency') }}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </template>
            </div>
          </div>

          <Spin size="large" fix v-if="loading"/>
        </div>
      </div>


      <div v-if="ledgers.length" class="text-center" style="padding: 50px 0 100px;">

        <h2 style="margin: 30px 50px">
          Avanzo di gestione:
          {{ $n(ledgers.map(l => l.stats.saldo).reduce((a, b) => (a || 0) + (b || 0), 0), 'currency') }}

          <!-- <FormItem label="Rimanenze di magazzino:">
            <NumInput/>
          </FormItem>
          <FormItem label="Debiti verso fornitori:">
            <NumInput/>
          </FormItem>
          <FormItem label="Crediti:">
            <NumInput/>
          </FormItem> -->
        </h2>

        <i>Conferma l'apertura del nuovo anno:</i>
        <br>

        <br>
        <Button type="success" size="large" @click.native="chiusuraApertura" :loading="saving">Continua apertura anno {{ year }}</Button>
      </div>
    </div>

    <hr>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [],
      year: (new Date).getFullYear(),
      ledgers: [],
      types: [
        { span: 24, label: 'Patrimoniale Attivo', filter: i => i.type == 'pa' },
        { span: 24, label: 'Patrimoniale Passivo', filter: i => i.type == 'pp' },
      ],
      loading: true,
      saving: false,
      ho_letto: false,
      inventory_stats: {},
    }
  },

  mounted() {
    this.$http.get('contab-years?company_id=' + this.$store.company.id).then(res => {
      this.years = res.data.map(y => parseInt(y))
    })
    this.$http.get(`inventory/startyear/${this.$store.company.id}/${this.year}`).then(res => {
      this.inventory_stats = res.data
    })
    this.refreshLedgers()
  },

  methods: {
    refreshLedgers () {
        var params = {
          company_id: this.$store.company.id,
          stats: 1,
          year: this.year-1,
          stat_all: 1,
          type: 'p%',
          exclude: [],
        }
        this.loading = true
        this.$http.get('ledgers', { params }).then(res => {
          this.ledgers = res.data
        }).finally(res => {
          this.loading = false
        })
    },
    chiusuraApertura () {
      var data = {}
      this.ledgers.forEach(led => (data[led.id] = led.stats.saldo))
      var data = {
        saldi: data,
      }
      this.saving = true
      this.$http.post(`close-open/${this.year}?company_id=` + this.$store.company.id, data).then(res => {
        alert('Operazione completata, verrai rimandato alla prima nota.')
        this.$router.push({name:'contabilita.prima-nota'})
      }).finally(() => {
        this.saving = false
      })
    }
  },
}
</script>

<style lang="scss">
.blocco {
  // border: 2px solid #aaa;
  // padding: 20px;
  // box-shadow: inset 0 0 10px rgba(0,0,0,.3);
  // background: #f6f6f8;

  .ivu-table {
    background: transparent;
    padding-left: 30px;
  }

  table {
    border-spacing: 0;
    margin-top: 20px;
    border-collapse: collapse;
    th {
      // background: #eaeaec;
      color: #000;
    }
    tr:nth-child(even) {
      background: #f4f4f7!important;
    }
    tr:hover {
      background: #f0f0f5!important;
    }
    td, th {
      background: transparent!important;
      padding: 0 10px!important;
      min-height: 0!important;
      height: auto!important;

      input {
        padding: 2px 10px;
        height: auto!important;
        border: 0;
        float: right;
        width: 110px;
        color: #fff;
        text-align: right;
      }

      .verde input {
        background: #1a6;
        color: #fff;
      }
      .rosso input {
        background: #f42;
        color: #fff;
      }
      .grigio input {
        background: #aaa;
        color: #fff;
      }
    }

    th {
      padding-top: 10px!important;
      padding-bottom: 10px!important;
    }
  }
}
</style>
